var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("connection-name", {
        ref: "name",
        attrs: { value: _vm.name },
        on: {
          input: function($event) {
            return _vm.$emit("update:name", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("connection-start-date", {
        attrs: { value: _vm.startDate },
        on: {
          input: function($event) {
            return _vm.$emit("update:startDate", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("toggle", {
        attrs: { value: _vm.isDisabled, label: _vm.resource("Bool_Disabled") },
        on: {
          input: function($event) {
            return _vm.$emit("update:isDisabled", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("connection-delay", {
        attrs: { value: _vm.delay },
        on: {
          input: function($event) {
            return _vm.$emit("update:delay", $event)
          }
        }
      }),
      _vm._v(" "),
      _vm.isEmail && _vm.emailCampaigns.length !== 0
        ? _c("connection-email", {
            attrs: { value: _vm.emailCampaign, options: _vm.emailCampaigns },
            on: {
              input: function($event) {
                return _vm.$emit("update:emailCampaign", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isTm && _vm.steamCampaigns.length !== 0
        ? _c("connection-steam", {
            attrs: { value: _vm.steamCampaign, options: _vm.steamCampaigns },
            on: {
              input: function($event) {
                return _vm.$emit("update:steamCampaign", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFacebook
        ? _c("toggle", {
            attrs: {
              value: _vm.groupByTitle,
              label: _vm.resource("JourneyBuilder_FilterSettings_GroupByTitle")
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:groupByTitle", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.availableActionConditions.length != 0
        ? _c("connection-actions", {
            attrs: {
              value: _vm.actionConditions,
              connectionId: _vm.id,
              conditions: _vm.availableActionConditions
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:actionConditions", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.hideContentSettings
        ? _c("connection-content", {
            ref: "contentSettings",
            attrs: {
              value: _vm.contentSettings,
              options: _vm.availableMidConditions
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:contentSettings", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }